import React from 'react';
import { Title, Wrapper } from './styled';

const Banner = () => (
  <Wrapper data-cy="top-banner">
    <Title>Special sale SS21 + Free express shipping</Title>
  </Wrapper>
);

export default Banner;
